<template>
  <section class="embla" ref="emblaNode">
    <div class="embla__viewport">
      <div class="embla__container">
        <div class="embla__slide" v-for="(product, pid) in products" v-bind:key="pid">
          <div class="embla__slide__card">
            <a class="embla__slide__card--thumb" :href="`${baseUrl}products/${product._id}`">
              <img :src="product.thumbnailUrls[0]" alt="broken">
            </a>
            <div class="embla__slide__card--details">
              <h4><a class="slide__card--title" @click="openProductDetail(product._id)">
                {{ product.name }}
              </a></h4>
              <p>
                <span
                  v-if="product.marked_price && product.marked_price.amount < product.price.amount"
                >
                  <strong class="underline" style="color: red">
                    {{ $n(product.price.amount, 'currency') }}
                  </strong>
                </span>
                &nbsp;&nbsp;
                <span>
                  <strong>{{ $n(product.marked_price.amount, 'currency') }}</strong>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="embla__controls">
      <div class="embla__buttons">
        <button class="embla__button embla__button--prev" type="button">
          <svg class="embla__button__svg" viewBox="0 0 532 532">
            <path
              fill="currentColor"
              d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z"
            ></path>
          </svg>
        </button>

        <button class="embla__button embla__button--next" type="button">
          <svg class="embla__button__svg" viewBox="0 0 532 532">
            <path
              fill="currentColor"
              d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import EmblaCarousel from 'embla-carousel';

export default {
  props: {
    products: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      carousel: null,
      options: {
        loop: true,
        align: 'start'
      },
      baseUrl: window.location.href
    };
  },

  mounted() {
    const emblaNode = this.$refs.emblaNode;
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
    const nextBtnNode = emblaNode.querySelector('.embla__button--next')
    this.carousel = EmblaCarousel(viewportNode, this.options);

    const removePrevNextBtnsClickHandlers = this.addPrevNextBtnsClickHandlers(
      this.carousel,
      prevBtnNode,
      nextBtnNode
    )

    this.carousel.on('destroy', removePrevNextBtnsClickHandlers)
  },

  methods: {
    addTogglePrevNextBtnsActive (emblaApi, prevBtn, nextBtn) {
      const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
        else prevBtn.setAttribute('disabled', 'disabled')

        if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
        else nextBtn.setAttribute('disabled', 'disabled')
      }

      emblaApi
        .on('select', togglePrevNextBtnsState)
        .on('init', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState)

      return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
      }
    },

    addPrevNextBtnsClickHandlers (emblaApi, prevBtn, nextBtn)  {
      const scrollPrev = () => {
        emblaApi.scrollPrev()
      }
      const scrollNext = () => {
        emblaApi.scrollNext()
      }
      prevBtn.addEventListener('click', scrollPrev, false)
      nextBtn.addEventListener('click', scrollNext, false)

      const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
      )

      return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
      }
    },

    openProductDetail(pid) {
      this.$router.push(`/products/${pid}`);
    },
  }
};
</script>
